import React from "react";

import { Icons } from "Assets/icons";
import TaskList from "../../project/Common/Counters/Counter/Default/CounterList/TaskList";

export const CounterList = {
    today: { 
        title: {
            default: "Tasks Due Today", 
            layout1: "Tasks due today"
        },
        classes: "dueToday", 
        type: "today",
        icon: {
            default: Icons.DueToday,
            active: Icons.DueTodayActive
        },
        component: (props) => <TaskList type={props.type} />
    },
    forReview: { 
        title: {
            default: "Tasks For Review", 
            layout1: "Tasks on review stage"
        },
        classes: "forReview", 
        type: "forReview",
        icon: {
            default: Icons.ForReview,
            active: Icons.ForReviewActive
        },
        component: (props) => <TaskList type={props.type} />
    },
    forApproval: { 
        title: {
            default: "Tasks For Approval", 
            layout1: "Tasks on approval stage"
        },
        classes: "forApproval", 
        type: "forApproval",
        icon: {
            default: Icons.ForApproval,
            active: Icons.ForApprovalActive
        },
        component: (props) => <TaskList type={props.type} />
    },
    delayed: { 
        title: {
            default: "Delayed Tasks", 
            layout1: "Delayed tasks"
        },
        classes: "delayed", 
        type: "delayed",
        icon: {
            default: <i class="material-icons">warning</i>,
            active: <i class="material-icons">warning</i>
        },
        component: (props) => <TaskList type={props.type} />
    },
    files: { 
        title: {
            default: "Inbox", 
            layout1: "Inbox"
        },
        classes: "activeFiles", 
        type: "files", 
        icon: {
            default: <i class="material-icons">inbox</i>,
            active: <i class="material-icons">inbox</i>
        },
        component: null
    }
}